import React from "react";
import { useTranslation } from "react-i18next";
import { PaymentStatus } from "../../features/payments/models/PaymentStatus";

/** Status pill for payments — green for money received, red for overdue, neutral otherwise. */
const PaymentStatusBadge: React.FC<{ status: PaymentStatus }> = ({ status }) => {
  const { t } = useTranslation();
  const classes: Record<PaymentStatus, string> = {
    [PaymentStatus.Received]: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300",
    [PaymentStatus.Overdue]: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300",
    [PaymentStatus.Invoiced]: "bg-grey-95 text-grey-30 dark:bg-primary-20 dark:text-grey-70",
    [PaymentStatus.Draft]: "bg-primary-95 text-primary-30 dark:bg-primary-20 dark:text-primary-90",
    [PaymentStatus.Voided]: "bg-grey-95 text-grey-50 line-through dark:bg-primary-20 dark:text-grey-60",
  };

  return (
    <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-medium ${classes[status]}`}>
      {t(`billing.paymentStatus.${status}`, { defaultValue: status })}
    </span>
  );
};

export default PaymentStatusBadge;
